/* src/Interviews/cards/InterviewFormCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { capitalize } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Button,
  Card,
  IconButton,
  Menu,
  MenuItem,
  Modal,
  Paper,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { Add, MoreHoriz } from '@material-ui/icons';

import { PaperHeader, HeaderTable } from '../../../../app/components';
import {
  fetchInterviewQuestions,
  addInterviewQuestion,
  updateInterviewQuestion,
  removeInterviewQuestion,
} from '../../actions';
import { getQuestions } from '../../selectors';

import styles from './styles';

class InterviewFormCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      mode: 'add',
      text: '',
      anchorEl: null,
      _id: null,
    };

    this._onOpenAddCard = this._onOpenAddCard.bind(this);
    this._onOpenEditCard = this._onOpenEditCard.bind(this);
    this._onCloseCard = this._onCloseCard.bind(this);
    this._onChange = this._onChange.bind(this);
    this._onMoreActions = this._onMoreActions.bind(this);
    this._onCloseMenu = this._onCloseMenu.bind(this);
    this._onSave = this._onSave.bind(this);
    this._onRemove = this._onRemove.bind(this);
  }

  componentDidMount() {
    this.props.fetchInterviewQuestions();
  }

  _onOpenAddCard() {
    this.setState({ open: true, mode: 'add', text: '' });
  }

  _onOpenEditCard() {
    this.setState({ open: true, mode: 'edit' });
  }

  _onCloseCard() {
    this.setState({ open: false });
  }

  _onChange({ target: { value } }) {
    this.setState({ text: value });
  }

  _onMoreActions({ _id, text }) {
    return event => { this.setState({ anchorEl: event.currentTarget, text, _id }); };
  }

  _onCloseMenu() {
    this.setState({ anchorEl: null });
  }

  _onSave() {
    const { mode, text, _id } = this.state;
    if (mode === 'add') {
      this.props.addInterviewQuestion({ input: { text } })
        .then(() => { this._onCloseCard(); });
    } else {
      this.props.updateInterviewQuestion({ question: _id, text })
        .then(() => {
          this._onCloseCard();
          this._onCloseMenu();
        });
    }
  }

  _onRemove() {
    this.props.removeInterviewQuestion({ question: this.state._id })
      .then(() => { this._onCloseMenu(); });
  }

  renderAddQuestion(classes) {
    const { open, text, mode } = this.state;
    return (
      <Modal open={open} onClose={this._onCloseCard}>
        <Card className={classes.addQuestionCard}>
          <AppBar position="static">
            <Toolbar>
              <Typography variant="title" color="inherit">
                {`${capitalize(mode)} a Question`}
              </Typography>
            </Toolbar>
          </AppBar>
          <div className={classes.textFieldContainer}>
            <TextField
              id="question"
              label="Question"
              value={text}
              fullWidth
              multiline
              onChange={this._onChange}
            />
          </div>
          <div className={classes.buttonContainer}>
            <Button color="secondary" onClick={this._onCloseCard}>
              {'Cancel'}
            </Button>
            <Button color="primary" onClick={this._onSave}>
              {'Save'}
            </Button>
          </div>
        </Card>
      </Modal>
    );
  }

  render() {
    const { classes, questions } = this.props;
    const { anchorEl } = this.state;
    return (
      <Paper className={classes.paper}>
        <PaperHeader text="Interview Form">
          <Button
            className={classes.expand}
            variant="fab"
            color="primary"
            mini
            aria-label="Add"
            onClick={this._onOpenAddCard}
          >
            <Add />
          </Button>
        </PaperHeader>
        <HeaderTable
          Action={datum => (
            <IconButton onClick={this._onMoreActions(datum)}>
              <MoreHoriz />
            </IconButton>
          )}
          header={false}
          center={false}
          data={questions}
        />
        {this.renderAddQuestion(classes)}
        <Menu
          id="question-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this._onCloseMenu}
        >
          <MenuItem onClick={this._onOpenEditCard}>Edit</MenuItem>
          <MenuItem onClick={this._onRemove}>Delete</MenuItem>
        </Menu>
      </Paper>
    );
  }
}

InterviewFormCard.propTypes = {
  classes: PropTypes.object.isRequired,
  questions: PropTypes.array.isRequired,
  fetchInterviewQuestions: PropTypes.func.isRequired,
  addInterviewQuestion: PropTypes.func.isRequired,
  updateInterviewQuestion: PropTypes.func.isRequired,
  removeInterviewQuestion: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  questions: getQuestions(state),
});

const mapDispatchToProps = dispatch => ({
  fetchInterviewQuestions: () => dispatch(fetchInterviewQuestions()()),
  addInterviewQuestion: params => dispatch(addInterviewQuestion(params)()),
  updateInterviewQuestion: params => dispatch(updateInterviewQuestion(params)()),
  removeInterviewQuestion: params => dispatch(removeInterviewQuestion(params)()),
});

export default compose(
  withStyles(styles, { name: 'InterviewFormCard' }),
  connect(mapStateToProps, mapDispatchToProps)
)(InterviewFormCard);



// WEBPACK FOOTER //
// ./src/modules/interviews/cards/InterviewFormCard/index.js